var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Planner",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.28,
    height: 19.28,
    viewBox: "0 0 19.28 19.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-273",
    d: "M338.286,805.587h19.28v19.28h-19.28Z",
    transform: "translate(-338.286 -805.587)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-274",
    d: "M355.71,812.672v-1.928a.386.386,0,0,0-.386-.386H341.443a.386.386,0,0,0-.386.386v1.928Zm.771-1.928v10.8a2.7,2.7,0,0,1-2.7,2.7h-10.8a2.7,2.7,0,0,1-2.7-2.7v-10.8a1.157,1.157,0,0,1,1.157-1.157h13.881A1.157,1.157,0,0,1,356.481,810.744Zm-15.424,2.7v8.1a1.928,1.928,0,0,0,1.928,1.928h10.8a1.928,1.928,0,0,0,1.928-1.928v-8.1Z",
    transform: "translate(-338.744 -806.502)",
    fill: "#326483"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path-275",
    d: "M350.841,818.384a.386.386,0,1,1,0,.771h-6.17a.386.386,0,1,1,0-.771Zm-3.085-3.085a.386.386,0,1,1,0,.771h-3.085a.386.386,0,1,1,0-.771Zm6.17-7.712a.386.386,0,0,1,.386.386v2.314a.386.386,0,1,1-.771,0v-2.314A.386.386,0,0,1,353.926,807.587Zm-8.483,0a.386.386,0,0,1,.386.386v2.314a.386.386,0,1,1-.771,0v-2.314A.386.386,0,0,1,345.443,807.587Z",
    transform: "translate(-339.659 -806.045)",
    fill: "#0c9aa3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/p.2e642d938821714dbf71385e0ffbd558.svg";
export { ForwardRef as ReactComponent };